import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import FallbackComponent from "./FallbackComponent"
import ReportScam from 'src/pages/both/scam';

const ManageBothDashboard = lazy(() => import("../pages/both/ManageBothDashboard"));
const BothPanelClientPostTask = lazy(() => import("../pages/both/post-a-task"));
const ManageBothTransactions = lazy(() => import("../pages/both/transactions"));
const BothProfileSettings = lazy(() => import("../pages/both/profile-settings"));
const BothAccountSettings = lazy(() => import("../pages/both/account-settings"));
const BothAcademicVerification = lazy(() => import("../pages/both/academic-certification"));
const BothSearch = lazy(() => import("../pages/both/search"));
const BothDispute = lazy(() => import("../pages/both/dispute-resolution"));
const Profile = lazy(() => import("../pages/common/profile"));
const StartTestPage = lazy(() => import("../pages/expert/academic-certification/StartTestPage"))

const BothUserPath = () => {
    return (
        <Routes>
            <Route path="*" element={<Navigate replace to={"/client-expert/orders"} />} />
            <Route path="orders" element={<Suspense fallback={<FallbackComponent />}><ManageBothDashboard /></Suspense>} />
            <Route path="create-new-task" element={<Suspense fallback={<FallbackComponent />}><BothPanelClientPostTask /></Suspense>} />
            <Route path="report-a-scam" element={<Suspense fallback={<FallbackComponent />}><ReportScam /></Suspense>} />
            <Route path="transactions" element={<Suspense fallback={<FallbackComponent />}><ManageBothTransactions /></Suspense>} />
            <Route path="search" element={<Suspense fallback={<FallbackComponent />}><BothSearch /></Suspense>} />
            <Route path="search/:subjectName" element={<Suspense fallback={<FallbackComponent />}><BothSearch /></Suspense>} />
            <Route path="profile-settings" element={<Suspense fallback={<FallbackComponent />}><BothProfileSettings /></Suspense>} />
            <Route path="account-settings" element={<Suspense fallback={<FallbackComponent />}><BothAccountSettings /></Suspense>} />
            <Route path="dispute-resolution" element={<Suspense fallback={<FallbackComponent />}><BothDispute /></Suspense>} />
            <Route path="academic-certification" element={<Suspense fallback={<FallbackComponent />}><BothAcademicVerification /></Suspense>} />
            <Route path="start-test" element={<Suspense fallback={<FallbackComponent />}><StartTestPage /></Suspense>} />
            <Route
                path="expert-profile/:userKeyCode"
                element={<Suspense fallback={<FallbackComponent />}><Profile /></Suspense>}
            />
        </Routes>
    );
}

export default BothUserPath;
